/**
 * Action Definitions - Central Export
 * Re-exports all entity-specific action definitions and universal actions
 * Provides convenient access to all action definitions
 */

// Entity-specific actions
export { contactDetailActions } from "@/features/contacts/actions/contact-actions";
export { taskDetailActions } from "@/features/tasks/actions/task-actions";
export { ticketDetailActions } from "@/features/tickets/actions/ticket-actions";
export { companyDetailActions } from "@/features/companies/actions/company-actions";
export { dealDetailActions } from "@/features/deals/actions/deal-actions";
export { communicationDetailActions } from "@/features/communications/actions/communication-actions";
export { timeEntryDetailActions } from "@/features/time-entries/actions/time-entry-actions";
export { contractDetailActions } from "@/features/contracts/actions/contract-actions";
export { userDetailActions } from "./entities/user-actions";

// Universal actions
export {
  universalDeleteAction,
  universalEditAction,
  universalSendEmailAction,
  universalLogActivityAction,
  universalAskMeridianAction,
  universalMakeTicketAction,
  universalLogTimeEntryAction,
  universalViewCompanyAction,
  universalCreateTaskAction,
  universalScheduleMeetingAction,
  universalLinkCompanyAction,
  universalEnrichAction,
  universalViewDetailsAction,
} from "./universal-actions";

// Shared action builders
export {
  createStatusAction,
  createCallAction,
  createGenerateContractAction,
  createSmAgreementAction,
  createGrantAgreementAction,
  createFillChecklistsAction,
  createManageAccessAction,
  createConsolidateAction,
  createResearchCompanyAction,
  createFindDecisionMakersAction,
  createLogDealAction,
  createDuplicateTaskAction,
  createQuickCompleteAction,
  createCompleteTaskAction,
  createSetDueDateAction,
  createAddUpdateAction,
  createAssignTicketAction,
  createCloseTicketAction,
  createAddCommentAction,
  createExportAction,
  createAdminOnlyAction,
  createEmployeeAndAdminAction,
  createAllAuthenticatedAction,
  createCustomRoleAction,
} from "./shared";
